export const kpiData = {
  totalUsers: 12480,
  activeUsers: 9630,
  totalServices: 3456,
  futureReminders: 1284,
  totalReminders: 4860,
  reminderFailures: 138,
  reminderSuccessRate: 96.8,
  conversionRate: 18.7,
  revenue: 293000,
  pendingReminders: 312,
  churnRate: 4.2,
  avgTicket: 182,
};

export const revenueChartData = [
  { month: 'Jan', receita: 18000, despesas: 9000 },
  { month: 'Fev', receita: 21000, despesas: 10000 },
  { month: 'Mar', receita: 26000, despesas: 12000 },
  { month: 'Abr', receita: 30000, despesas: 14000 },
  { month: 'Mai', receita: 34000, despesas: 16000 },
  { month: 'Jun', receita: 38000, despesas: 17000 },
];

export const userGrowthData = [
  { month: 'Jan', novos: 640, ativos: 5400 },
  { month: 'Fev', novos: 730, ativos: 5900 },
  { month: 'Mar', novos: 810, ativos: 6400 },
  { month: 'Abr', novos: 920, ativos: 7100 },
  { month: 'Mai', novos: 1010, ativos: 8200 },
  { month: 'Jun', novos: 1180, ativos: 9630 },
];

export const servicesByCategory = [
  { name: 'Instalação', value: 920 },
  { name: 'Limpeza', value: 870 },
  { name: 'Manutenção preventiva', value: 760 },
  { name: 'Recarga de gás', value: 520 },
  { name: 'Outros', value: 386 },
];

export const funnelData = [
  { stage: 'Visitas', value: 25400 },
  { stage: 'Onboarding', value: 11800 },
  { stage: 'Cadastro', value: 6100 },
  { stage: 'Assinantes', value: 1780 },
  { stage: 'Recorrentes', value: 690 },
];

export const reminderFunnelData = [
  { stage: 'Enviados', value: 4280 },
  { stage: 'Contatados', value: 1190 },
  { stage: 'Agendados', value: 520 },
];

export type MockUser = {
  id: string;
  phone: string;
  phone_verified: boolean;
  email: string | null;
  name: string | null;
  company_name: string | null;
  created_at: string;
  updated_at: string;
};

export const mockUsers: MockUser[] = [
  {
    id: 'USR-001',
    phone: '+5511999991111',
    phone_verified: true,
    email: 'joao@empresa.com',
    name: 'João Silva',
    company_name: 'Empresa João Clima',
    created_at: '2026-01-10T09:00:00.000Z',
    updated_at: '2026-03-20T14:30:00.000Z',
  },
  {
    id: 'USR-002',
    phone: '+5511988882222',
    phone_verified: true,
    email: 'maria@empresa.com',
    name: 'Maria Andrade',
    company_name: 'Andrade Refrigeração',
    created_at: '2025-11-02T11:15:00.000Z',
    updated_at: '2026-03-18T08:05:00.000Z',
  },
  {
    id: 'USR-003',
    phone: '+5511977773333',
    phone_verified: false,
    email: null,
    name: 'Carlos Souza',
    company_name: null,
    created_at: '2026-02-18T16:40:00.000Z',
    updated_at: '2026-03-01T10:00:00.000Z',
  },
];

export type MockService = {
  id: string;
  user_id: string;
  client_id: string;
  type:
    | 'instalacao'
    | 'limpeza'
    | 'manutencao'
    | 'manutencao_preventiva'
    | 'manutencao_corretiva'
    | 'recarga_gas'
    | 'troca_filtro'
    | 'higienizacao'
    | 'outro';
  type_other_description: string | null;
  service_date: string;
  next_maintenance_months: number;
  next_maintenance_date: string;
  equipment_reference: string | null;
  value: number | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
};

export const mockServices: MockService[] = [
  {
    id: 'SRV-0101',
    user_id: 'USR-001',
    client_id: 'CLT-001',
    type: 'manutencao_preventiva',
    type_other_description: null,
    service_date: '2026-03-11',
    next_maintenance_months: 6,
    next_maintenance_date: '2026-09-11',
    equipment_reference: 'Sala 01 - Split 12k',
    value: 250,
    notes: null,
    created_at: '2026-03-11T10:00:00.000Z',
    updated_at: '2026-03-11T10:00:00.000Z',
  },
  {
    id: 'SRV-0102',
    user_id: 'USR-002',
    client_id: 'CLT-002',
    type: 'instalacao',
    type_other_description: null,
    service_date: '2026-03-29',
    next_maintenance_months: 6,
    next_maintenance_date: '2026-09-29',
    equipment_reference: 'Recepção - Cassete',
    value: 890,
    notes: 'Instalação com suporte reforçado',
    created_at: '2026-03-28T15:20:00.000Z',
    updated_at: '2026-03-29T18:10:00.000Z',
  },
  {
    id: 'SRV-0103',
    user_id: 'USR-003',
    client_id: 'CLT-003',
    type: 'limpeza',
    type_other_description: null,
    service_date: '2026-03-21',
    next_maintenance_months: 3,
    next_maintenance_date: '2026-06-21',
    equipment_reference: null,
    value: 180,
    notes: null,
    created_at: '2026-03-21T09:45:00.000Z',
    updated_at: '2026-03-21T09:45:00.000Z',
  },
];

export type MockReminder = {
  id: string;
  user_id: string;
  client_id: string;
  service_id: string | null;
  expected_date: string;
  equipment_reference: string | null;
  status: 'sent' | 'contacted' | 'scheduled' | 'cancelled';
  sent_at: string[];
  contacted_at: string | null;
  scheduled_date: string | null;
  value_charged: number | null;
  create_reminder_for_date: boolean;
  created_at: string;
  updated_at: string;
};

export const mockReminders: MockReminder[] = [
  {
    id: 'REM-9901',
    user_id: 'USR-001',
    client_id: 'CLT-001',
    service_id: 'SRV-0101',
    expected_date: '2026-09-11',
    equipment_reference: 'Sala 01 - Split 12k',
    status: 'sent',
    sent_at: ['2026-09-04T09:00:00.000Z'],
    contacted_at: null,
    scheduled_date: null,
    value_charged: null,
    create_reminder_for_date: true,
    created_at: '2026-09-04T09:00:00.000Z',
    updated_at: '2026-09-04T09:00:00.000Z',
  },
  {
    id: 'REM-9902',
    user_id: 'USR-002',
    client_id: 'CLT-002',
    service_id: 'SRV-0102',
    expected_date: '2026-09-29',
    equipment_reference: 'Recepção - Cassete',
    status: 'contacted',
    sent_at: ['2026-09-22T10:30:00.000Z'],
    contacted_at: '2026-09-22T11:05:00.000Z',
    scheduled_date: null,
    value_charged: null,
    create_reminder_for_date: true,
    created_at: '2026-09-22T10:30:00.000Z',
    updated_at: '2026-09-22T11:05:00.000Z',
  },
  {
    id: 'REM-9903',
    user_id: 'USR-003',
    client_id: 'CLT-003',
    service_id: null,
    expected_date: '2026-06-21',
    equipment_reference: null,
    status: 'scheduled',
    sent_at: ['2026-06-14T11:00:00.000Z', '2026-06-20T11:00:00.000Z'],
    contacted_at: '2026-06-20T13:20:00.000Z',
    scheduled_date: '2026-06-23',
    value_charged: 180,
    create_reminder_for_date: true,
    created_at: '2026-06-14T11:00:00.000Z',
    updated_at: '2026-06-20T13:20:00.000Z',
  },
];

export type MockPlan = {
  id: string;
  name: string;
  price: number;
  users: number;
  active: boolean;
  features: string[];
};

export const mockPlans: MockPlan[] = [
  {
    id: 'plan-free',
    name: 'Free',
    price: 0,
    users: 2830,
    active: true,
    features: ['1 usuário', 'Até 20 lembretes/mês', 'Suporte por e-mail'],
  },
  {
    id: 'plan-start',
    name: 'Start',
    price: 79,
    users: 1710,
    active: true,
    features: ['5 usuários', 'Lembretes ilimitados', 'Relatórios básicos'],
  },
  {
    id: 'plan-pro',
    name: 'Pro',
    price: 149,
    users: 920,
    active: true,
    features: ['15 usuários', 'Automação avançada', 'Relatórios completos'],
  },
  {
    id: 'plan-enterprise',
    name: 'Enterprise',
    price: 299,
    users: 220,
    active: false,
    features: ['Usuários ilimitados', 'SLA dedicado', 'Suporte prioritário'],
  },
];

export type MockExpenseType = 'infraestrutura' | 'marketing' | 'ferramentas' | 'operacional' | 'outros';

export type MockExpense = {
  id: string;
  name: string;
  type: MockExpenseType;
  cost: number;
  createdAt: string;
  updatedAt: string;
};

export const mockExpenses: MockExpense[] = [
  {
    id: 'EXP-001',
    name: 'Hospedagem da plataforma',
    type: 'infraestrutura',
    cost: 299.9,
    createdAt: '2026-03-01T10:00:00.000Z',
    updatedAt: '2026-03-01T10:00:00.000Z',
  },
  {
    id: 'EXP-002',
    name: 'Campanha Meta Ads',
    type: 'marketing',
    cost: 950,
    createdAt: '2026-03-03T14:15:00.000Z',
    updatedAt: '2026-03-08T09:30:00.000Z',
  },
  {
    id: 'EXP-003',
    name: 'Ferramenta de CRM',
    type: 'ferramentas',
    cost: 189.9,
    createdAt: '2026-03-05T08:20:00.000Z',
    updatedAt: '2026-03-05T08:20:00.000Z',
  },
];

export const reminderSettings = {
  intervals: [7, 3, 1],
  maxRetries: 3,
  quietHoursStart: '22:00',
  quietHoursEnd: '08:00',
};

